/* eslint-disable */
// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roomScenes: null,
};

export const roomSceneSlice = createSlice({
  name: 'roomScene',
  initialState,
  reducers: {
    setRoomScenes: (state, { payload }) => {
      state.roomScenes = payload;
    },
    deleteRoomScene: (state, { payload }) => {
      state.roomScenes = state.roomScenes?.filter((r) => r._id !== payload);
    },
  },
});

export const roomSceneSliceCachedActions = [];
export const { setRoomScenes, deleteRoomScene } = roomSceneSlice.actions;

export const roomSceneReducer = roomSceneSlice.reducer;
